const { createTemplate } = require("../../../src/settings/config");

const mikuKzConfig = createTemplate({
    useDeskId: "155789_32337",
    themeColor: "#0B0B0B",
    yandexVerification: "",
    ymId: 95695379,
    name: "miku-kz",
    apiName: "miku",
    domain: "kz",
    idGTM: "WV24FVPJ",
    font: "<style>@font-face{font-family:'Montserrat';font-style:normal;font-weight:400;font-display:swap;src:local('Montserrat'),url('/fonts/400.woff2') format('woff2'),url('/fonts/400.woff') format('woff')}@font-face{font-family:'Montserrat';font-style:normal;font-weight:500;font-display:swap;src:local('Montserrat'),url('/fonts/500.woff2') format('woff2'),url('/fonts/500.woff') format('woff')}@font-face{font-family:'Montserrat';font-style:normal;font-weight:600;font-display:swap;src:local('Montserrat'),url('/fonts/600.woff2') format('woff2'),url('/fonts/600.woff') format('woff')}@font-face{font-family:'Montserrat';font-style:normal;font-weight:700;font-display:swap;src:local('Montserrat'),url('/fonts/700.woff2') format('woff2'),url('/fonts/700.woff') format('woff')}</style>",
});

module.exports = mikuKzConfig;
